export function normalizeAadhaar(value = "") {
  return value.replace(/\D/g, "").slice(0, 12);
}

export function isValidAadhaar(value = "") {
  return /^\d{12}$/.test(value);
}

export function maskAadhaar(value = "") {
  const clean = normalizeAadhaar(value);
  if (clean.length !== 12) return "";
  return `${clean.slice(0, 4)}XXXXXXXX`;
}

export function encryptForNow(value = "") {
  return btoa(value);
}

export function isValidGST(value = "") {
  return /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][A-Z0-9]Z[A-Z0-9]$/i.test(
    value.trim()
  );
}